import { Survicate } from '@survicate/survicate-web-surveys-wrapper';
import { createContext } from 'react';

export const SurvicateContext = createContext<Survicate | null>(null);
